var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon-btn",on:{"click":_vm.handleClick}},[(!_vm.$slots.default)?_c('span',{class:[_vm.suffix, _vm.icon],style:({
      fontSize: `${_vm.size}px`,
      fontWeight: _vm.fontWeight,
    })}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }